import { gql } from '@apollo/client';

import buildLimitAndOffset from 'api/pagination/buildLimitAndOffset';
import tag from './tag';

export const TAGS_WITH_PIPELINE_COUNT_QUERY = 'TagsWithPipelineCount';

export const GET_TAGS_WITH_PIPELINE_COUNT = gql`
  query ${TAGS_WITH_PIPELINE_COUNT_QUERY}(
    $limit: Int!
    $offset: Int!
    $orderBy: [tags_order_by!]
  ) {
    tagsAggregate: tags_aggregate(where: { type: { _eq: PIPELINE } }) {
      aggregate {
        count
      }
    }
    tags(
      where: { type: { _eq: PIPELINE } }
      limit: $limit
      offset: $offset
      order_by: $orderBy
    ) {
      ...tag
      pipelineTagsAggregate: pipeline_tags_aggregate {
        aggregate {
          count
        }
      }
      pipelineTags: pipeline_tags(order_by: { pipeline: { name: asc } }) {
        pipeline {
          name
        }
      }
    }
  }
  ${tag}
`;

export function buildVariables({ page, perPage, sort }) {
  return {
    ...buildLimitAndOffset({ page, perPage }),
    orderBy: { [sort.field]: sort.direction },
  };
}
